export interface Category {
  name: string;
  url: string;
  imageQuery: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageQuery: 'Clean%20minimalist%20sneaker%20display%20on%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20elegant%20composition%20with%20gentle%20shadows%2C%20lifestyle%20aesthetic%20with%20neutral%20tones%2C%20high%20detail%20texture%2C%20professional%20fashion%20presentation',
    imageSeq: 'category-shoes-01',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageQuery: 'Premium%20hoodie%20flat%20lay%20on%20warm%20cream%20background%2C%20minimalist%20fashion%20photography%2C%20soft%20diffused%20lighting%2C%20textured%20fabric%20detail%2C%20neutral%20aesthetic%2C%20editorial%20style%20with%20clean%20composition%2C%20high%20quality%20garment%20presentation',
    imageSeq: 'category-hoodies-02',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageQuery: 'Classic%20cotton%20t-shirt%20elegantly%20folded%20on%20light%20beige%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%20from%20window%2C%20clean%20shadow%20detail%2C%20neutral%20warm%20tones%2C%20professional%20fashion%20editorial%20style',
    imageSeq: 'category-tshirts-03',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageQuery: 'Stylish%20bomber%20jacket%20displayed%20on%20minimalist%20wooden%20hanger%2C%20warm%20cream%20wall%20background%2C%20soft%20studio%20lighting%2C%20textured%20fabric%20visible%2C%20elegant%20fashion%20photography%2C%20clean%20composition%2C%20neutral%20aesthetic',
    imageSeq: 'category-jackets-04',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageQuery: 'Tailored%20trousers%20neatly%20arranged%20on%20light%20warm%20background%2C%20minimalist%20fashion%20flat%20lay%2C%20soft%20natural%20illumination%2C%20fabric%20texture%20visible%2C%20clean%20editorial%20style%2C%20professional%20garment%20photography%2C%20neutral%20palette',
    imageSeq: 'category-pants-05',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageQuery: 'Classic%20baseball%20cap%20on%20minimalist%20cream%20surface%2C%20soft%20studio%20lighting%20from%20left%2C%20clean%20product%20photography%2C%20textured%20fabric%20detail%2C%20warm%20neutral%20tones%2C%20elegant%20editorial%20presentation%2C%20professional%20accessory%20display',
    imageSeq: 'category-headwear-06',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageQuery: 'Coordinated%20clothing%20set%20elegantly%20displayed%20on%20warm%20beige%20background%2C%20minimalist%20fashion%20photography%2C%20soft%20diffused%20lighting%2C%20harmonious%20color%20coordination%2C%20clean%20editorial%20composition%2C%20lifestyle%20aesthetic',
    imageSeq: 'category-sets-07',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageQuery: 'Premium%20cotton%20underwear%20neatly%20folded%20on%20light%20cream%20surface%2C%20clean%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20fabric%20texture%20detail%2C%20elegant%20presentation%2C%20neutral%20warm%20tones%2C%20professional%20style',
    imageSeq: 'category-underwear-08',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageQuery: 'Athletic%20jersey%20displayed%20on%20minimalist%20warm%20background%2C%20sportswear%20product%20photography%2C%20soft%20studio%20lighting%2C%20fabric%20texture%20detail%2C%20clean%20editorial%20composition%2C%20professional%20fashion%20presentation%2C%20neutral%20aesthetic',
    imageSeq: 'category-jersey-09',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageQuery: 'Fashion%20accessories%20collection%20elegantly%20arranged%20on%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20watches%20and%20jewelry%20display%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%2C%20professional%20presentation',
    imageSeq: 'category-accessories-10',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageQuery: 'Designer%20handbag%20on%20minimalist%20beige%20pedestal%2C%20luxury%20product%20photography%2C%20soft%20studio%20lighting%2C%20leather%20texture%20detail%2C%20elegant%20editorial%20composition%2C%20warm%20neutral%20background%2C%20professional%20fashion%20display',
    imageSeq: 'category-bags-11',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageQuery: 'Premium%20leather%20belt%20coiled%20elegantly%20on%20light%20cream%20surface%2C%20minimalist%20accessory%20photography%2C%20soft%20natural%20lighting%2C%20leather%20texture%20detail%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20tones%2C%20professional%20presentation',
    imageSeq: 'category-belts-12',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageQuery: 'Elegant%20perfume%20bottle%20on%20minimalist%20warm%20background%2C%20luxury%20fragrance%20photography%2C%20soft%20studio%20lighting%20with%20gentle%20highlights%2C%20glass%20reflection%20detail%2C%20clean%20editorial%20composition%2C%20neutral%20aesthetic%2C%20professional%20product%20display',
    imageSeq: 'category-perfumes-13',
  },
  {
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageQuery: 'Miscellaneous%20fashion%20items%20artistically%20arranged%20on%20cream%20background%2C%20minimalist%20product%20collection%20photography%2C%20soft%20natural%20lighting%2C%20varied%20textures%20and%20materials%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20tones',
    imageSeq: 'category-other-14',
  },
];